import { render, staticRenderFns } from "./decorations.vue?vue&type=template&id=484a49f1&"
import script from "./decorations.vue?vue&type=script&lang=js&"
export * from "./decorations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports